import actionTypes from '../../../actions/Entities/MarketSpace/actionTypes';

function getInitialState() {
  return {
    ids: [],
    byId: {},
  };
}

function reduce(state, marketSpace) {
  const next = { ...state };
  if (!next.ids.includes(marketSpace.id)) {
    next.ids.push(marketSpace.id);
  }
  next.byId[marketSpace.id] = marketSpace;
  return next;
}

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case actionTypes.FETCHED_ALL: {
      const { marketSpaces } = action.payload;
      return marketSpaces.reduce(reduce, getInitialState());
    }
    case actionTypes.FETCHED_MULTIPLE: {
      const { marketSpaces } = action.payload;
      return marketSpaces.reduce(reduce, state);
    }
    case actionTypes.FETCHED_SINGLE: {
      const { marketSpace } = action.payload;
      return reduce(state, marketSpace);
    }
    case actionTypes.DELETED_SINGLE: {
      const { marketSpaceId } = action.payload;
      const nextState = { ...state };
      if (nextState.ids.includes(marketSpaceId)) {
        const idx = nextState.ids.indexOf(marketSpaceId);
        nextState.ids.splice(idx, 1);
      }
      if (nextState.byId[marketSpaceId]) {
        delete nextState.byId[marketSpaceId];
      }
      return nextState;
    }
    default:
      return state;
  }
}
